<template>
  <div id="nav-menu">
    <MobileMenuItem
      :selected="show === 'header'"
      @update:showPanel="click('header')"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d=" M 500 46C 514 46 528 53 540 65C 540 65 950 475 950 475C 960 485 960 490 950 500C 950 500 915 535 915 535C 905 545 895 545 885 535C 885 535 515 165 515 165C 505 155 495 155 485 165C 485 165 115 535 115 535C 105 545 95 545 85 535C 85 535 50 500 50 500C 40 490 40 485 50 475C 50 475 460 65 460 65C 472 53 486 46 500 46C 500 46 500 46 500 46M 500 207C 505 207 510 210 515 215C 515 215 835 535 835 535C 845 545 850 550 850 565C 850 565 850 850 850 850C 850 885 835 900 800 900C 800 900 600 900 600 900C 590 900 575 885 575 875C 575 875 575 725 575 725C 575 710 565 700 550 700C 550 700 450 700 450 700C 435 700 425 710 425 725C 425 725 425 875 425 875C 425 885 410 900 400 900C 400 900 200 900 200 900C 165 900 150 885 150 850C 150 850 150 565 150 565C 150 550 155 545 165 535C 165 535 485 215 485 215C 490 210 495 207 500 207C 500 207 500 207 500 207"
          fill="#fff"
        />
      </svg>
    </MobileMenuItem>
    <MobileMenuItem
      :selected="show === 'tactics'"
      @update:showPanel="click('tactics')"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d=" M 613 150C 613 212 562 263 500 263C 438 263 387 212 387 150C 387 88 438 38 500 38C 562 38 613 88 613 150C 613 150 613 150 613 150M 500 287C 519 287 546 266 575 263C 600 263 621 274 636 289C 651 304 663 325 663 350C 663 350 663 600 663 600C 662 614 654 627 642 634C 642 634 613 648 613 648C 613 648 613 900 613 900C 612 921 596 937 575 937C 575 937 500 937 500 937C 500 937 425 937 425 937C 404 937 388 921 387 900C 387 900 387 648 387 648C 387 648 358 634 358 634C 346 627 338 614 337 600C 337 600 337 350 337 350C 337 325 349 304 364 289C 379 274 400 263 425 263C 449 263 470 288 500 287C 500 287 500 287 500 287"
          fill="#fff"
        />
      </svg>
    </MobileMenuItem>
    <MobileMenuItem
      :selected="show === 'stats'"
      @update:showPanel="click('stats')"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d=" M 800 113C 862 113 912 163 912 225C 912 234 911 243 909 251C 909 251 1000 309 1000 309C 1000 309 1000 399 1000 399C 1000 399 869 314 869 314C 850 329 826 337 800 337C 791 337 783 337 775 335C 775 335 588 631 588 631C 603 650 613 674 613 700C 613 762 562 812 500 812C 438 812 387 762 387 700C 387 693 388 686 390 679C 390 679 273 611 273 611C 253 627 228 638 200 638C 180 638 161 632 144 622C 144 622 0 746 0 746C 0 746 0 647 0 647C 0 647 95 566 95 566C 90 553 88 539 88 525C 88 463 138 412 200 412C 262 412 312 463 312 525C 312 532 312 539 310 546C 310 546 427 614 427 614C 447 598 472 588 500 588C 509 588 517 588 525 590C 525 590 712 294 712 294C 697 275 688 251 688 225C 688 163 738 113 800 113C 800 113 800 113 800 113"
          fill="#fff"
        />
      </svg>
    </MobileMenuItem>
    <MobileMenuItem
      :selected="show === 'suggestions'"
      @update:showPanel="click('suggestions')"
    >
      <svg
        v-if="warnings"
        width="24"
        height="24"
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d=" M 592 59C 592 59 592 59 592 59C 592 59 685 249 685 249C 685 249 896 280 896 280C 896 280 895 280 895 280C 933 285 965 312 977 348C 989 386 978 425 952 452C 952 452 800 599 800 599C 800 599 835 809 835 809C 835 809 835 809 835 809C 841 846 827 885 795 908C 777 920 757 927 736 927C 721 927 705 923 689 916C 689 916 689 915 689 915C 689 915 501 817 501 817C 501 817 313 915 313 915C 313 915 313 915 313 915C 279 933 239 930 207 908C 207 908 207 907 207 907C 207 907 207 907 207 907C 176 885 161 847 167 809C 167 809 167 809 167 809C 167 809 203 599 203 599C 203 599 51 452 51 452C 51 452 50 452 50 452C 24 425 14 385 25 349C 25 349 25 348 25 348C 25 348 26 348 26 348C 38 312 70 285 108 280C 108 280 107 280 107 280C 107 280 317 249 317 249C 317 249 410 59 410 59C 410 59 410 59 410 59C 428 25 462 3 501 3C 540 3 575 26 592 59C 592 59 592 59 592 59M 478 93C 478 93 382 287 382 287C 382 287 382 287 382 287C 372 306 354 320 331 322C 331 322 333 322 333 322C 333 322 118 354 118 354C 118 354 118 354 118 354C 109 355 100 362 97 372C 94 381 97 391 103 398C 103 398 260 550 260 550C 260 550 261 552 261 552C 274 566 280 585 278 605C 278 605 278 606 278 606C 278 606 241 821 241 821C 239 831 244 841 251 847C 260 852 271 853 279 849C 279 849 471 748 471 748C 471 748 471 747 471 747C 490 738 512 738 531 747C 531 747 531 748 531 748C 531 748 723 848 723 848C 727 851 731 852 736 852C 741 852 747 850 751 847C 751 847 751 846 751 846C 751 846 751 846 751 846C 759 841 763 832 761 821C 761 821 725 607 725 607C 725 607 725 609 725 609C 721 587 729 564 743 549C 743 549 744 549 744 549C 744 549 899 398 899 398C 906 391 909 381 906 372C 906 372 905 372 905 372C 905 372 905 371 905 371C 902 362 895 355 885 354C 885 354 885 354 885 354C 885 354 669 322 669 322C 669 322 671 322 671 322C 648 320 630 306 620 287C 620 287 620 287 620 287C 620 287 524 93 524 93C 519 82 512 78 501 78C 492 78 482 83 478 93C 478 93 478 93 478 93"
          fill="#fff"
        />
      </svg>
      <svg
        v-else
        width="24"
        height="24"
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d=" M 925 425C 925 425 770 576 770 576C 763 583 760 592 762 601C 762 601 798 815 798 815C 802 839 793 863 773 877C 762 885 749 889 736 889C 726 889 716 887 706 882C 706 882 514 781 514 781C 506 777 496 777 488 781C 488 781 296 882 296 882C 275 893 249 891 229 877C 210 863 200 839 204 815C 204 815 241 601 241 601C 242 592 239 583 233 576C 233 576 77 425 77 425C 60 408 54 383 61 360C 69 337 89 320 113 317C 113 317 327 285 327 285C 336 284 344 278 348 270C 348 270 444 76 444 76C 455 54 477 40 501 40C 526 40 547 54 558 76C 558 76 654 270 654 270C 658 278 666 284 675 285C 675 285 890 317 890 317C 914 320 934 337 941 360C 949 383 942 408 925 425"
          fill="#FBB810"
        />
      </svg>
    </MobileMenuItem>
  </div>
</template>

<script>
import MobileMenuItem from "@/components/MobileMenuItem";
export default {
  components: {
    MobileMenuItem,
  },

  props: {
    show: String,
  },

  methods: {
    click(newValue) {
      this.$emit("update:showPanel", newValue);
    },
  },

  computed: {
    warnings() {
      return this.$store.getters.warnings.length > 0;
    },
  },
};
</script>

<style scoped>
#nav-menu {
  display: none;
}

@media only screen and (max-width: 767px) {
  #nav-menu {
    display: block;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 64px;
    background: magenta;
    display: flex;
    justify-content: space-between;
    border-top: solid 1px #003577;
    z-index: 1000;
  }

  svg {
    color: #fff;
  }
}
</style>
